import _ from 'lodash';
import { getQueryParamsObject } from '../../../utils/getQueryParamsObject';
import { browserHistory } from 'react-router';

export const canPlay = (idGroup, infinite) =>
  _.get(infinite, `${idGroup}.live.canPlay`, 0) === 1;

export const getTimeShift = (idGroup, infinite) =>
  _.get(infinite, `${idGroup}.timeshift.value`, 0) * 3600 * 1000;

export const getNpvr = (idGroup, infinite) =>
  _.get(infinite, `${idGroup}.npvr.value`, 0);

  export const isCatchUp = queryParams => {
    if(queryParams){
      const params = getQueryParamsObject(queryParams);
      if (params.startTime !== undefined && params.endTime !== undefined) {
      return true;
    }
    return false;
    } else {
      const location = browserHistory.getCurrentLocation();
      if (
        location.query.startTime !== undefined &&
        location.query.endTime !== undefined
      ) {
        return true;
      }
      return false;
    }
  };
